import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-rabbitmq',
	templateUrl:'./RabbitMQPluginPage.html',
	styles: [],
	styleUrls:['./RabbitMQPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class RabbitMQPluginPage
{
	mdContent_114 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp</groupId>
  <artifactId>jwebmp-rabbitmq</artifactId>
</dependency>
\`\`\``;
	mdContent_115 = `\`\`\`kotlin
implementation("com.jwebmp:jwebmp-rabbitmq:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_116 = `\`\`\`java
// module-info.java
module com.myapp {
    requires com.jwebmp.rabbit;
    requires com.guicedee.rabbit;
}

// Environment variables:
// RABBITMQ_HOST=localhost
// RABBITMQ_PORT=5672
// RABBITMQ_WEB_STOMP_PORT=15674
\`\`\``;
	mdContent_117 = `\`\`\`java
<!-- Auto-subscribe to groups when component is rendered -->
<div [data-rabbit-groups]="['notifications', 'updates']">
  Real-time content here
</div>
\`\`\``;
	mdContent_118 = `\`\`\`java
// module-info.java
module com.myapp {
    requires com.jwebmp.rabbit;
    requires com.guicedee.rabbit;
}

// Environment variables:
// RABBITMQ_HOST=localhost
// RABBITMQ_PORT=5672
// RABBITMQ_WEB_STOMP_PORT=15674

// Enable RabbitMQ Web STOMP plugin:
// rabbitmq-plugins enable rabbitmq_web_stomp
\`\`\``;
}
